module.exports = __webpack_public_path__ + "img/example.56e81535.jpg";